import { render, staticRenderFns } from "./UploadViewer.vue?vue&type=template&id=108d2d1a&scoped=true"
import script from "./UploadViewer.vue?vue&type=script&lang=js"
export * from "./UploadViewer.vue?vue&type=script&lang=js"
import style0 from "./UploadViewer.vue?vue&type=style&index=0&id=108d2d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d2d1a",
  null
  
)

export default component.exports